import { getFromServerTopic } from "@utility/slice";
import { createSlice } from "@reduxjs/toolkit";

const SLICE = "accounts";

export const getFromServer = (action, contextOptionsFn, payloadFn) =>
  getFromServerTopic({ topic: SLICE, action, contextOptionsFn, payloadFn });

export const getAccounts = getFromServer("getAccounts");

export const getAccountById = getFromServer(
  "getAccountById",
  async ({ arg }) => arg,
  async (payload) => payload,
);

export const getAccountsByUnit = getFromServer(
  "getAccountsByUnit",
  async ({ arg }) => arg,
  async (payload) => payload,
);

export const updateAccount = getFromServer(
  "updateAccount",
  async ({ arg }) => arg,
  async (payload) => payload,
);

export const slice = createSlice({
  name: SLICE,
  initialState: {
    accounts: [],
    selectedAccount: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAccounts.fulfilled, (state, action) => {
        state.accounts = action.payload.response;
      })
      .addCase(getAccountById.fulfilled, (state, action) => {
        state.selectedAccount = action.payload.response;
      })
      .addCase(getAccountsByUnit.fulfilled, (state, action) => {
        state.accounts = action.payload.response;
      })
      .addCase(updateAccount.fulfilled, (state, action) => {
        return action.payload.response;
      });
  },
});

export const actions = {
  getAccounts,
  getAccountById,
  getAccountsByUnit,
  updateAccount,
};

export default slice.reducer;
